import React from 'react'

import config from 'config/apps'

import { LinkWithoutUnderline } from '../MenuAlert/LinkWithoutUnderline'
import { MenuAlert } from '../MenuAlert/MenuAlert'

export const FlexOrderAlert = () => (
  <MenuAlert title="Editing here will undo the portion changes you made in the app">
    Custom portions is a trial feature, only available in the{' '}
    <LinkWithoutUnderline
      href={`https://geo.itunes.apple.com/gb/app/gousto-uks-no1-recipe-kit/id${config.appStoreId}?mt=8`}
    >
      Gousto app
    </LinkWithoutUnderline>
    . To keep your portion changes, make any further updates there.
  </MenuAlert>
)
